module.exports = __webpack_public_path__ + "static/media/ScaleIII_green.e3b9209d.png";